import React from "react";
import * as yup from "yup";
import {ListEditor} from "../../components/list-editor";
import {
    SundryType,
    SundryTypeQueryQuery,
    useSundryTypeQueryQuery,
    useSundryTypesMutationMutation
} from "../../generated/graphql";
import {useLocation} from "react-router";
import {uniqueId} from "../../utils";

const columns = [{
    header: 'Name',
    accessor: 'name',
    dataType:'text'
}
];

function newRow():SundryType {
    return {
        id: uniqueId(),
        name: ''
    }
}

const schema =  yup.array().of(
        yup.object().shape({
        'name': yup.string().required()
    })
);

function getValues(data:SundryTypeQueryQuery) {
    return data?.sundryTypes??[];
}


function OtherTypes() {
    const query = useSundryTypeQueryQuery();
    const [mutation,mutationResult] = useSundryTypesMutationMutation();
    const url = useLocation().pathname;
    return (
        <ListEditor
            saveResult={mutationResult}
            columns={columns}
            validationSchema={schema}
            title="Other Types"
            mutation={mutation}
            query={query}
            permission="othertypes"
            newRow={newRow}
            newRowLabel="Add Other Type"
            baseUrl={url}
            getValues={getValues}
            className="other-types"
        />);
}

export default OtherTypes;
